var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.propOrderNum != ''),expression:"propOrderNum != ''"}],staticClass:"mineTest-foot__orderNum flex flex--middle"},[_c('span',{staticClass:"orderId flex__item"},[_c('div',{staticClass:"wrapper"},[_c('span',{staticClass:"text"},[_vm._v("订单编号：")]),_vm._v(_vm._s(_vm.propOrderNum))])]),_vm._v(" "),_c('button',{ref:"copyBtn",staticClass:"copyTip",attrs:{"id":"copyTip","data-clipboard-text":_vm.propOrderNum+''}},[_vm._v("复制\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/mine/mineTestOrderNum.vue?vue&type=template&id=add56cf4&
// module id = null
// module chunks = 